
import * as rcl from "./_csRcl";

const _ldrz = rcl.grtAtom('ldrz', {
  bShow: false,
});

export const useLdrz = () => {
  const _dz = rcl.grtStt(_ldrz);
  const _show = () => {
    _dz.set({
      bShow: true
    })
  };
  const _hide = () => {
    _dz.set({
      bShow: false
    })
  };
  return {
    ... _dz,
    show: _show,
    hide: _hide,
  }
};
